const CMS_BASE_URL = 'https://api.dev.auxo.dk/public/content/pages'

export async function fetchAllPages() {
  try {
    const response = await fetch(CMS_BASE_URL)
    if (!response.ok) {
      throw new Error(`Kunne ikke hente CMS-data: ${response.statusText}`)
    }
    return await response.json()
  } catch (error) {
    console.error('Fejl ved hentning af CMS-sider:', error)
    return []
  }
}

export async function fetchPageBySlug(pageSlug) {
  const pages = await fetchAllPages()
  return pages.find(p => p.page_slug === pageSlug) || null
}
